import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZoomIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 20 26",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "linear-gradient",
		x1: .5,
		x2: .5,
		y2: 1,
		gradientUnits: "objectBoundingBox",
		children: [/* @__PURE__ */ _jsx("stop", {
			offset: 0,
			stopColor: "#faf5ff"
		}), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#f0f8fd"
		})]
	}) }), /* @__PURE__ */ _jsxs("g", {
		id: "Group_2701",
		"data-name": "Group 2701",
		transform: "translate(-718 -1565)",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				id: "Rectangle_1556",
				"data-name": "Rectangle 1556",
				transform: "translate(718 1579)",
				fill: "none",
				stroke: "#1d1739",
				strokeWidth: 1,
				children: [/* @__PURE__ */ _jsx("rect", {
					width: 12,
					height: 12,
					rx: 2,
					stroke: "none"
				}), /* @__PURE__ */ _jsx("rect", {
					x: .5,
					y: .5,
					width: 11,
					height: 11,
					rx: 1.5,
					fill: "none"
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Rectangle_416",
				"data-name": "Rectangle 416",
				transform: "translate(722 1571)",
				stroke: "#1d1739",
				strokeWidth: 1,
				fill: "url(#linear-gradient)",
				children: [/* @__PURE__ */ _jsx("rect", {
					width: 16,
					height: 16,
					rx: 2,
					stroke: "none"
				}), /* @__PURE__ */ _jsx("rect", {
					x: .5,
					y: .5,
					width: 15,
					height: 15,
					rx: 1.5,
					fill: "none"
				})]
			}),
			/* @__PURE__ */ _jsx("text", {
				id: "_",
				"data-name": "+",
				transform: "translate(724.5 1584)",
				fill: "#f85c87",
				fontSize: 20,
				fontFamily: "BrownStd-RegularAlt, BrownStd",
				children: /* @__PURE__ */ _jsx("tspan", {
					x: 0,
					y: 0,
					children: "+"
				})
			})
		]
	})]
});
export default SvgZoomIcon;
